/*
 * @Descripttion:
 * @version:
 * @Author: wlk
 * @Date: 2023-11-28 17:02:22
 * @LastEditors: dengyao
 * @LastEditTime: 2025-07-02 11:21:17
 */
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { dataCenter, expressManagement, orderManagement, customManagement, orderList, setting } from './route'
import routerBefore from './routerBefore'
import { pvTrack } from '@/utils/track'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Layout',
    component: () => import('@/layout/index.vue'),
    children: [
      {
        path: '/',
        name: 'Home',
        redirect: '/dataDashboard'
      },
      {
        path: '/notFound',
        name: 'NotFound',
        component: () => import('@/views/notfound/Index.vue'),
        meta: { title: '404', requiresAuth: false, keepAlive: true }
      },
      {
        path: '/noAuth',
        name: 'NoAuth',
        component: () => import('@/views/noauth/Index.vue'),
        meta: { title: '403', requiresAuth: false, keepAlive: true }
      },
      {
        path: '/collection',
        name: 'Collection',
        component: () => import('@/views/collection/Index.vue'),
        meta: { title: '收款', requiresAuth: false, keepAlive: true }
      },
      ...dataCenter,
      ...expressManagement,
      ...orderManagement,
      ...customManagement,
      ...orderList,
      ...setting
    ]
  },
  {
    path: '/auditInterception',
    name: 'AuditInterception',
    component: () => import('@/views/auditInterception/Index.vue'),
    meta: { title: '审核拦截', requiresAuth: false, keepAlive: false }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/Index.vue'),
    meta: { title: '登录', requiresAuth: false, keepAlive: false }
  },
  {
    path: '/forgetPwd',
    name: 'ForgetPwd',
    component: () => import('@/views/forgetPwd/Index.vue'),
    meta: { title: '忘记密码', requiresAuth: false, keepAlive: false }
  },
  {
    path: '/:w+',
    name: '*',
    redirect: '/notFound'
  }
]

const index = createRouter({
  history: createWebHistory(),
  routes
})

index.afterEach((to, from) => {
  pvTrack(to, from)
})

//路由导航
routerBefore(index)
export default index
